app.factory('roleService', ['$http', '$location', function($http, $location) {
    return {
        get : function(id) {
            return $http
            .get('api/roles/' + id)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        add: function(role){
            return $http
            .post('api/roles/add', role)
            .then(res => {
                alert.success("New role saved successfully!");
                $location.path("/roles/");

                return res.data;
            }, errorHandler);
        },

        find: function(filter){
            return $http
            .post('api/roles/', filter)
            .then(res => {
                return res.data;
            }, errorHandler);
        },

        update: function(role){
            return $http
            .put('api/roles/', role)
            .then(res => {
                alert.success("Role updated successfully!")
                $location.path("/roles");

                return res.data;
            }, errorHandler);
        },

        remove: function(id){
            if(confirm("Are you sure?")){

            return $http
            .delete('api/roles/' + id)
            .then(() => {
                alert.success("Role deleted successfully!")
                $location.path("/roles");
            }, errorHandler);
        }
        }
    };
} ]);
